module.exports = __webpack_public_path__ + "img/shop-pa.f6092b4b.svg";